import Vue from 'vue'
import Router from 'vue-router'
import Hello from '@/components/Hello'
import ProductSearch from '@/components/ProductSearch'
import ProductCreate from '@/components/ProductCreate'
import ProductUpdate from '@/components/ProductUpdate'
import Login from '@/components/Login'
import FamilyAll from '@/components/FamilyAll'
import UserAll from '@/components/UserAll'
import DuplicateJob from '@/components/DuplicateJob'
import RoofAll from '@/components/RoofAll'
import ColourAll from '@/components/ColourAll'
import ExtraAll from '@/components/ExtraAll'
import Extra from '@/components/Extra'
import { requireAuth } from '../auth'

Vue.use(Router)

export default new Router({
  routes: [
    {
      path: '/',
      name: 'Hello',
      component: Hello,
      beforeEnter: requireAuth
    },

    {
      path: '/product/search',
      name: 'ProductSearch',
      component: ProductSearch,
      beforeEnter: requireAuth
    },

    {
      path: '/product/create',
      name: 'ProductCreate',
      component: ProductCreate,
      beforeEnter: requireAuth
    },

    {
      path: '/product/:id',
      name: 'ProductUpdate',
      component: ProductUpdate,
      beforeEnter: requireAuth
    },

    {
      path: '/duplicateJobs/:id',
      name: 'DuplicateJob',
      component: DuplicateJob,
      beforeEnter: requireAuth
    },

    {
      path: '/login',
      name: 'Login',
      component: Login
    },

    {
      path: '/family/all',
      name: 'FamilyAll',
      component: FamilyAll,
      beforeEnter: requireAuth
    },

    {
      path: '/roof/all',
      name: 'RoofAll',
      component: RoofAll,
      beforeEnter: requireAuth
    },

    {
      path: '/colour/all',
      name: 'ColourAll',
      component: ColourAll,
      beforeEnter: requireAuth
    },

    {
      path: '/user/all',
      name: 'UserAll',
      component: UserAll,
      beforeEnter: requireAuth
    },

    {
      path: '/extra/all',
      name: 'ExtraAll',
      component: ExtraAll,
      beforeEnter: requireAuth
    },

    {
      path: '/extra/:id',
      name: 'Extra',
      component: Extra,
      beforeEnter: requireAuth
    }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js